import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const onboardingSummarySchema = z.object({
  seller_account_name: z.string().nullable().optional(),
  account_region: z.array(z.string()).optional(),
  amazon_seller_marketplaces: z.array(z.string()).optional(),
  amazon_mws_seller_id: z.string().nullable().optional(),
  eu_amazon_mws_seller_id: z.string().nullable().optional(),
  fe_amazon_mws_seller_id: z.string().nullable().optional(),
  amazon_profile_ids: z
    .string()
    .nullable()
    .optional()
    .transform((val) => (val ? JSON.parse(val) : {}))
    .pipe(z.record(z.string(), z.record(z.string(), z.coerce.string()))),
  amazon_mws_auth_token: z.string().optional(),
  eu_amazon_mws_auth_token: z.string().optional(),
  fe_amazon_mws_auth_token: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});

export type OnboardingSummary = z.infer<typeof onboardingSummarySchema>;

export const onboardingSummaryApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getOnboardingSummary",
    method: "get",
    path: "/onboardingsummary/",
    status: 200,
    response: onboardingSummarySchema,
  }).build(),
);
